var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var defaultOriginKernelConfig = {
    /**
     * @deprecated
     * 默认创建的最大VideoNode数量。此值会影响到可以同时预加载的视频数，例如如果需要同时预加载3个视频，这个值就需要指定为3+1
     * <br>【注】：仅原生播放内核时有效
     */
    maxVideoNodeCount: 1,
    /**
     * 提前结束播放的时间（考虑到某些视频最后只有音频，有需求需要剪掉视频最末尾的一段播放，x5浏览器是0.1s）
     * <br>【注】：仅原生播放内核时有效
     */
    advanceEndTime: 0,
    /**
     * 原生播放内核实现切换时，为了拼接顺畅，可能会把下一个视频提前一点点播放
     * <br>【注】：仅原生播放内核时有效
     */
    prePlayNextTime: 0,
};
export function mergeKernelConfig(config) {
    return __assign(__assign({}, config), { originKernelConfig: __assign(__assign({}, defaultOriginKernelConfig), config.originKernelConfig) });
}
